module.exports = FormData;
//# sourceMappingURL=form-data.js.map